import React from 'react';
import logoImg from '/assets/logo.webp';

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = "w-10 h-10" }) => {
  return (
    <div className={`relative flex items-center justify-center ${className}`}>
      {/* 
        Si deseas usar una imagen PNG/SVG externa, descomenta la siguiente línea 
        y ajusta la ruta src. Asegúrate de poner el archivo en tu carpeta public.
      */}
      <img src={logoImg} alt="Stellionet Logo" loading="lazy" decoding="async" width={40} height={40} className="w-full h-full object-contain" />
    </div>
  );
};

export default Logo;